import React from 'react';
//noinspection NpmUsedModulesInstalled
import { withBlockExtensions } from '@plone/volto/helpers';
import DownloadItems from './DownloadItems';
import DownloadDetailsModal from '../DownloadDetailsModal';
import './static/style/block.less';
import './static/style/modal.less';

const DownloadBlockView = (props) => {
  return (
    <>
      <DownloadItems {...props} />
      <DownloadDetailsModal />
    </>
  );
};

export default withBlockExtensions(DownloadBlockView);
